import React, { useCallback, useEffect, useState } from 'react';
import DeleteDashboardModal from 'adapter/in/dashboards/pages/Modals/DeleteModal';
import { isSome } from 'fp-ts/lib/Option';
import { DeleteDashboardCriteriaBuilder } from 'use-case/dashboard/delete/deleteDashboardCriteria';
import { useDashboard } from 'adapter/in/dashboards/context/Dashboard';

export const useOnDeleteDashboardModal = (onSuccess: () => void) => {
    const { delete: remove, deleteError, deleteIsLoading, deleteResult, deleteReset } = useDashboard();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [dashboardForDeletion, setDashboardForDeletion] = useState('');

    const handleOnDelete = useCallback(
        (dashboardId: string) => {
            setShowDeleteModal(true);
            setDashboardForDeletion(dashboardId);
        },
        [deleteResult]
    );

    const handleOnDeleteConfirm = useCallback(
        () => !!dashboardForDeletion && remove(DeleteDashboardCriteriaBuilder.create().withId(dashboardForDeletion).build()),
        [dashboardForDeletion]
    );

    useEffect(() => {
        if (isSome(deleteResult)) {
            setShowDeleteModal(false);
            setDashboardForDeletion('');
            deleteReset();
            onSuccess();
        }
    }, [deleteResult]);

    const onDeleteModal = (
        <DeleteDashboardModal
            showModal={showDeleteModal}
            setShowModal={setShowDeleteModal}
            success={isSome(deleteResult)}
            isLoading={deleteIsLoading}
            error={isSome(deleteError)}
            onDelete={handleOnDeleteConfirm}
        />
    );

    return { handleOnDelete, onDeleteModal };
};
